import type { FaireProductEntity } from "../../entity_types/product";

export const p_3sf6fwh7nj: FaireProductEntity = {
  token: "p_3sf6fwh7nj",
  type: "product",
  name: "Honey Lavender Hand Cream\u00a01 oz \u2013 Flower Market ",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/d46bc152f67b0d70d3c42006deefc605683a363c9b9499a240d9ce696618bd6b.png",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a4993b4dbfb17de94b2291d13c4bd5efcd68f0f113ab6456602b31be53db0414.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
